import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import $ from "jquery";
import axios from "axios";

let parkBeginnDate;
let parkBeginnTime;
let parkDuration;

const SettingsCamera = (props) => {
  let jwt = localStorage.getItem("JWT");
  let link = localStorage.getItem("link");
  let data = props.data;

  const [cameraLink, setCameraLink] = useState(null);
  const [numberOverwriteVisible, setNumberOverwriteVisible] = useState(false);

  const [licensePlateImage, setLicensePlateImage] = useState('');
  const [carImage, setCarImage] = useState('');

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;

    if (data?.carImageAvailable === true) {
      axios.get(`${link}/api/lot/CarImage/?lotId=${data.id}`).then((response) => {
        setCarImage(`data:;base64,${response.data}`);
      });
    }

    
    if (data?.licensePlateImageAvailable === true) {
      axios.get(`${link}/api/lot/LicensePlateImage/?lotId=${data.id}`).then((response) => {
        setLicensePlateImage(`data:;base64,${response.data}`);
      });
    }

    parkBeginnDate = null;
    parkBeginnTime = null;
    parkDuration = null;
    if (data.lastTimeLotGotOccupied != null && data.occupied == true) {
      let lastTimeLotGotOccupied = new Date(data.lastTimeLotGotOccupied);
      let now = new Date();

      parkBeginnDate =
        ("0" + lastTimeLotGotOccupied.getDate()).slice(-2) +
        "." +
        ("0" + (lastTimeLotGotOccupied.getMonth() + 1)).slice(-2) +
        "." +
          lastTimeLotGotOccupied.getFullYear();
      parkBeginnTime =
        ("0" + lastTimeLotGotOccupied.getHours()).slice(-2) +
        ":" +
        ("0" + lastTimeLotGotOccupied.getMinutes()).slice(-2) +
        ":" +
        ("0" + lastTimeLotGotOccupied.getSeconds()).slice(-2);

      let diffMS = Math.abs(now - lastTimeLotGotOccupied);

      let days = Math.floor(diffMS / (24 * 60 * 60 * 1000));
      let daysms = diffMS % (24 * 60 * 60 * 1000);
      let hours = Math.floor(daysms / (60 * 60 * 1000));
      let hoursms = diffMS % (60 * 60 * 1000);
      let minutes = Math.floor(hoursms / (60 * 1000));

      let d = ("0" + days).slice(-2) + "d ";
      if (days < 1) {
        d = "";
      }
      if (days > 99) {
        d = days + "d ";
      }
      let h = ("0" + hours).slice(-2) + "h ";
      let m = ("0" + minutes).slice(-2) + "m";

      parkDuration = d + h + m;
    }

    // Cleanup: when modal unmounts
    return () => {
      // Clear URL to force browser to close connection
      $('img[alt="CameraStream"]').attr("src", "");
      setCameraLink(null);
    };
  }, [props.data]);

  function time() {
    let time;

    if (data.parkingTimeRestrictionInMinutes > 0) {
      function TimeLimit(num) {
        let daysT = Math.floor(num / 1440);
        let hoursT = Math.floor((num - daysT * 1440) / 60);
        let minutesT = Math.round(num % 60);

        let dT = ("0" + daysT).slice(-2) + "d ";
        if (daysT < 1) {
          dT = "";
        }
        if (daysT > 99) {
          dT = daysT + "d ";
        }
        let hT = ("0" + hoursT).slice(-2) + "h ";
        let mT = ("0" + minutesT).slice(-2) + "m";

        return dT + hT + mT;
      }

      time = TimeLimit(data.parkingTimeRestrictionInMinutes);
    } else {
      time = null;
    }

    if (time != null && data.parkingTimeRestrictionEnabled == true) {
      return (
        <div>
          <tr>
            <td className="td-cam breakwords">
              {props.t("elementeAllgemein.zeitueberwachung")}
            </td>
            <td className="td-cam">{time}</td>
          </tr>
        </div>
      );
    } else {
      return (
        <div>
          <tr>
            <td className="td-cam breakwords">
              {props.t("elementeAllgemein.zeitueberwachung")}
            </td>
            <td className="td-cam">{props.t("allgemein.aus")}</td>
          </tr>
        </div>
      );
    }
  }

  function getModus() {
    let modus;

    if (data.mode == 0) {
      modus = props.t("lot.modes.Automatic");
    } else if (data.mode == 1) {
      modus = props.t("lot.modes.ManualFree");
    } else if (data.mode == 2) {
      modus = props.t("lot.modes.ManualOccupied");
    } else if (data.mode == 3) {
      modus = props.t("lot.modes.ManualBlocked");
    }

    return modus;
  }

  function getStatus() {
    let status;

    if (data.occupied == true) {
      status = props.t("allgemein.besetzt");
    } else status = props.t("allgemein.frei");

    if (data.defect == null) {
      status = props.t("allgemein.unbekannt");
    }

    return status;
  }

  function getCameraStream() {
    return (
      <>
        <img
          key={data.id} // force remount when ID changes
          src={cameraLink}
          alt="CameraStream"
          width="100%"
          height="100%"
          style={{ pointerEvents: "none" }}
        />
      </>
    );
  }

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      {cameraLink != null && (
          <div style={{ width: "100%", height: "400px" }}>
            {getCameraStream()}
          </div>
      )}

      {carImage !== '' && (
          <div style={{ width: "100%", height: "400px" }}>
            <img
                key={data.id} // force remount when ID changes
                src={carImage}
                alt="CameraImage"
                width="100%"
                height="100%"
            />
          </div>
      )}

      <tr>
        <td className="td-cam">{props.t("allgemein.zustand")}</td>
        <td className="td-cam">
          {getStatus()}
          <br></br> ({getModus()})
        </td>
      </tr>

      <tr>
        <td className="td-cam">Typ</td>
        <td className="td-cam">{data.lotType.name}</td>
      </tr>

      <tr>
        <td className="td-cam">{props.t("elementeAllgemein.area")}</td>
        <td className="td-cam">{data.parentAreaName}</td>
      </tr>

      {data.occupied == true && (
        <>
          {data.licensePlate != null && (
            <tr>
              <td className="td-cam">{props.t("allgemein.kennzeichen")}</td>
              <td className="td-cam">{data.licensePlate}</td>

              {licensePlateImage !== '' && (
                  <tr>
                    <td>&nbsp;</td>
                    <td className="td-cam">
                      <img src={licensePlateImage} alt="LicensePlate Image" style={{maxWidth: "100px"}}/>
                    </td>
                  </tr>
              )}
            </tr>
          )}

          <div className="timetable">
            <tr>
              <td className="td-cam">{props.t("lot.parkBeginn")}</td>
              <td className="td-cam">
                {parkBeginnDate}
                <br></br>
                {parkBeginnTime}
              </td>
            </tr>
            <tr>
              <td className="td-cam">{props.t("lot.parkDauer")}</td>
              <td className="td-cam">{parkDuration}</td>
            </tr>
          </div>
          {time()}
        </>
      )}

      <tr>
        <td className="td-cam">{props.t("allgemein.helligkeit")}</td>
        <td className="td-cam">
          {props.t("allgemein.aktuell")}: {data.lightIntensity_Current}%
          <br></br>
          {props.t("allgemein.standard")}: {data.lightIntensity_Default}%
        </td>
      </tr>

      {numberOverwriteVisible && data.licensePlate != null && (
        <div
          style={{ paddingLeft: "20px", marginTop: "20px" }}
          className="flex-col-1"
        >
          Nummernschild überschreiben
          <div className="flex-iac">
            <input
              type="text"
              style={{ width: "200px", marginRight: "20px" }}
            />
            <button class="button">{props.t("allgemein.speichern")}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default withNamespaces()(SettingsCamera);
